import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ListRooms.scss";
import BackBtn from "../../btncomponent/BackBtn";

const ListRooms = () => {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/category`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setCategory(data), setLoading(false);
      });
  }, []);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="container mt-5">
      <h2 className="mb-5 text-muted">List Rooms</h2>
      <BackBtn location="/admin/dashboard" />
      {showloading()}
      <div className="row mt-5">
        {category.map((data) => {
          return (
            <div className="col-sm-3" key={data._id}>
              <Link
                to={`/listrooms/room/${data._id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="card mb-3 roomcard">
                  <div className="card-body">
                    <h5 className="card-title text-center">{data.name}</h5>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListRooms;
